import {
  GETNOTIFICATIONCOUNT,
  GETNOTIFICATIONCOUNTFAILED,
} from "../actions/NotificationActions";

const initialState = {
  count: 0,
};

export const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETNOTIFICATIONCOUNT:
      return {
        ...state,
        count: action.payload,
      };
    case GETNOTIFICATIONCOUNTFAILED:
      return {
        ...state,
        count: 0,
      };

    default:
      return state;
  }
};
